import { render, staticRenderFns } from "./Dashboard-Escola.vue?vue&type=template&id=69ed964e&scoped=true&"
import script from "./Dashboard-Escola.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Escola.vue?vue&type=script&lang=js&"
import style0 from "../assets/estilo-dashboard.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/estilo-dashboard-2.css?vue&type=style&index=1&lang=css&"
import style2 from "./Dashboard-Escola.vue?vue&type=style&index=2&id=69ed964e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed964e",
  null
  
)

component.options.__file = "Dashboard-Escola.vue"
export default component.exports